import React from 'react';
import { useState, useEffect } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonIcon } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { Loader, CustomModal, CustomTable } from 'citric_components';

import Detail from './Detail';

import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate, faEdit } from '@fortawesome/free-solid-svg-icons';
import { isCATI } from '../Releases/Releases';

import { App } from '@capacitor/app';

import CardImg from '../../images/card.png';
import { useNavigate, useLocation } from 'react-router';

import conf from '../../config.json';
import { generateKey, logD } from '../Util/Util';
import Header from '../Dashboard/Header';

export default function Launchs(props) {
    logD("Launchs", props);
    const release = props.release;
    const [launchs, setLaunchs] = useState(props.release.launchs);
    const [selected, setSelected] = useState(null);
    //Update modal
    const [updateModal, setUpdateModal] = useState(false);
    //Modal show flag
    const [show, setShow] = useState(false);
    //Modal show/close methods
    const handleShow = () => setShow(true);

    var hiddenColumns = ['idLaunch', 'summary'];

    if(props.token.r != 4) {
        hiddenColumns = [];
    }

    const navigate =useNavigate();

    function handleClose() {
        setUpdateModal(false);
        setShow(false);
    }

    function handleUpdate(row) {
        setSelected(row);
        setUpdateModal(true);
        handleShow();
    }

    function handleFinish() {
        console.log('finish');
        handleClose();
        reload();
    }

    function back() {
        
        //setResponses(null);
        //props.setLaunch(null);
        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    function getLaunchs(item) {
        setLaunchs(null);
        let fd = new URLSearchParams();
        fd.append("idU", props.token.u);
        fd.append("idR", item.idDraft);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allLaunchs';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        .then((data) => {
            logD("Launchs", data);
            props.setRelease(data);
            if (data && Array.isArray(data.launchs)) {
                
                data.launchs.forEach((launch) => {
                    var total = 0;
                    if (launch.summary) {
                        total += launch.summary.access;
                        total += launch.summary.quotafull;
                        total += launch.summary.screenout;
                        total += launch.summary.dropout;
                        total += launch.summary.complete;
                    }
                    launch.summary.total = total;
                });
            }
            setLaunchs(data.launchs);

        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    App.addListener('backButton', ({canGoBack}) => {
          
          if(!canGoBack){
            App.exitApp();
          } else {
            back();
          }
    });

    function reload() {
        setLaunchs(null);
        getLaunchs(release);
    }

    useEffect(() => {
        if(launchs == null || launchs.length == 0) {
            getLaunchs(release);
        }
    }, [props]);

    const columns = [
        {
            Header: t('id'),
            accessor: 'idLaunch',
        },
        {
            Header: t('actions'),
            id: 'actions',
            Cell: row => (
                <>
                    {props.token.r == 1 && <IonButton onClick={e=> handleUpdate(row.row.original)}><FontAwesomeIcon icon={faEdit} /></IonButton>}
                    {isCATI(row.row.original) &&
                        <IonButton color="primary" onClick={(e) => {
                                e.preventDefault();
                                release.launchs = []; 
                                row.row.original.release = release;
                                props.setLaunch(row.row.original);
                                if(props.token.r != 4) {
                                    props.setInterviewer(row.row.original.urls[0].idUser);
                                }
                                setTimeout(function(){
                                    navigate("../cati/"+row.row.original.idLaunch);
                                }, 100);
                            }
                        }>
                            {t('cati')}
                        </IonButton>
                    }
                    {!isCATI(row.row.original) && <IonButton color="primary" onClick={ (e) => { 
                        e.preventDefault();
                        var keyNote = generateKey(row.row.original.idLaunch);
                        props.setKeyNote(keyNote);
                        props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/a/' + row.row.original.urls[0].data + "?note=" + keyNote);
                        props.setTitle(release.name + " - " + row.row.original.description);
                        props.setTypeUrl('survey_start');
                        if(props.token.r != 4) {
                            props.setInterviewer(row.row.original.urls[0].idUser);
                        }
                        setTimeout(function(){
                            navigate('../webview/'+row.row.original.idLaunch);
                        }, 100);
                    }}>{t('start_survey')}</IonButton>}

                    {(props.token.r == 1  || row.row.original.idType == 5 || (props.userConfig != null && props.userConfig.history)) && <IonButton color="tertiary" onClick={(e) => {
                            e.preventDefault();
                            row.row.original.release = release;
                            props.setLaunch(row.row.original);
                            props.setTotal(row.row.original.summary ? row.row.original.summary.total : 0);
                            if(props.token.r != 4 && row.row.original.urls[0] != null) {
                                props.setInterviewer(row.row.original.urls[0].idUser);
                            }
                            setTimeout(function(){
                                navigate("../history/"+row.row.original.idLaunch);
                            }, 100);
                        }
                    }>{t('history')}</IonButton>}
                    <IonButton color="secondary" onClick={(e) => {
                        e.preventDefault();
                        props.setLaunch(row.row.original);
                        props.setUrl(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + props.project.idProject + '&sv=' + release.idDraft + '&pl=' + row.row.original.idLaunch + '&qa=1&nomb=1' + ((row.row.original.idType == 10) ? '&acc=1' : ''));
                        props.setTitle(t('tracking'));
                        props.setTypeUrl('tracking');
                        setTimeout(function(){
                            navigate('../webview/'+row.row.original.idLaunch);
                        }, 100);
                    }}>{t('tracking')}</IonButton>
                </>
            ),
        },
        {
            Header: t('planning'),
            accessor: 'description',
        },
        {
            id: 'start',
            Header: t('start'),
            sortType: (a, b) => {
                return b.original.start - a.original.start;
            },
            accessor: (d) => {
                if(d.start == null) {
                    return '';
                } else {
                    return new Date(d.start).toLocaleString(navigator.language);
                }
            },

        }, {
            id: 'end',
            Header: t('end'),
            sortType: (a, b) => {
                return b.original.end - a.original.end;
            },
            accessor: (d) => {
                if(d.end == null) {
                    return '';
                } else {
                    return new Date(d.end).toLocaleString(navigator.language);
                }
            },
        },
        {
            Header: t('access'),
            id: 'AC',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.access
                }
                return 0;
            }
        },
        {
            Header: t('complete'),
            id: 'F',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.complete
                }
                return 0;
            }
        }, {
            Header: t('dropout'),
            id: 'A',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.dropout
                }
                return 0;
            }
        }, {
            Header: t('screenout'),
            id: 'D',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.screenout
                }
                return 0;
            }
        }, {
            Header: t('quotafull'),
            id: 'DC',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.quotafull
                }
                return 0;
            }
        }
    ];

    return (
        <>
            <IonPage id="responses">
                <IonHeader>
                    <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                    <IonToolbar className="toolbar-azul">
                        <IonButtons slot="start">
                            <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                        </IonButtons>
                        <IonTitle>{release.name}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    {launchs == null && <Loader />}
                    <Row className="text-end">
                        <Col>
                            <Button variant="link"><FontAwesomeIcon icon={faRotate} onClick={() => reload()}/></Button>
                        </Col>
                    </Row>
                    {
                        launchs != null &&
                        <>
                           <CustomTable keyField='description' desc={false} data={launchs} columns={columns} isFilter={true} isPagination={false} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} isExport={true}/>
                           {show && updateModal && <CustomModal id='updateLaunch' className="big-modal" title={t('launch')} body={ <Detail token={props.token.token} handleFinish={handleFinish} handleError={props.handleError} selected={selected} release={release}/>} show={show} handleClose={handleClose}/>}
                        </>
                    }
                </IonContent>
            </IonPage>
        </>
    );
}